import usePaywall from '../../dashboard/paywall/usePaywall';
import { PaywallState } from '../../dashboard/paywall/paywallTypes';
import useIsAgentEnabled from '../../aiAgentCenter/useIsAgentEnabled';
import { useUnhappyStates } from '../environments/useUnhappyStates';
import { AgentType } from '@server/ai';
import { useIsSIUser } from '../assessments/useIsSIUser';

export enum GetStartedVariant {
  Assessments = 'assessments',
  HomeFree = 'home-free',
  HomeTrial = 'home-trial',
  Agentic = 'agentic',
  Classic = 'classic',
}

export const useGetStartedVariant = (): GetStartedVariant => {
  const { isPaywallActive, paywallState } = usePaywall();
  const isInTrial = paywallState === PaywallState.IN_TRIAL;
  const isDocumentationAgentEnabled = useIsAgentEnabled(AgentType.Documentation);
  const { noConnectedOrg, connectionError } = useUnhappyStates();
  const isSIUser = useIsSIUser();

  if (isSIUser) return GetStartedVariant.Assessments;
  if (isPaywallActive) return GetStartedVariant.HomeFree;
  if (isInTrial) return GetStartedVariant.HomeTrial;
  if (isDocumentationAgentEnabled && !noConnectedOrg && !connectionError)
    return GetStartedVariant.Agentic;
  return GetStartedVariant.Classic;
};
